
export const enum WorkerRequest {
    Error = 0,
    Connect,
    Disconnect,
    Subscription,
    PreLoadData,
    DataUpdated,
    Resized,
    Complete
}

export const enum WorkerResult {
    Success = 1,
    Failed = -1
}

export interface WorkerMessage {
    request: WorkerRequest;
    result: WorkerResult | undefined;
    data: any | undefined;
}

const MILL_SECONDS = 1000
export const DEFAULT_DELAY = 5 * MILL_SECONDS; // Realtime Delay time (Smooths Line)
